import {
  CREATE_RESOURCE_INIT,
  CREATE_RESOURCE_SUCCESS,
  CREATE_RESOURCE_FAILED,
  GET_RESOURCE_ANALYTICS_INIT,
  GET_RESOURCE_ANALYTICS_SUCCESS,
  GET_RESOURCE_ANALYTICS_FAILED,
  GET_TOTAL_RESOURCES_INIT,
  GET_TOTAL_RESOURCES_SUCCESS,
  GET_TOTAL_RESOURCES_FAILED,
  GET_RESOURCES_BY_ROLES_INIT,
  GET_RESOURCES_BY_ROLES_SUCCESS,
  GET_RESOURCES_BY_ROLES_FAILED,
  GET_RESOURCE_DETAILS_BY_ID_INIT,
  GET_RESOURCE_DETAILS_BY_ID_SUCCESS,
  GET_RESOURCE_DETAILS_BY_ID_FAILED,
  UPDATE_RESOURCE_DETAILS_INIT,
  UPDATE_RESOURCE_DETAILS_SUCCESS,
  UPDATE_RESOURCE_DETAILS_FAILED,
  GET_RESOURCE_ALLOCATION_MATRIX_INIT,
  GET_RESOURCE_ALLOCATION_MATRIX_SUCCESS,
  GET_RESOURCE_ALLOCATION_MATRIX_FAILED,
  GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS,
  GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_SUCCESS,
  GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_FAILED,
  UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE,
  UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_SUCCESS,
  UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_FAILED,
  GET_UTILIZATION_LEVEL_INIT,
  GET_UTILIZATION_LEVEL_SUCCESS,
  GET_UTILIZATION_LEVEL_FAILED,
  CLEAR_RM_LANDING_DATA,
  GET_UTILIZATION_PERCENTAGE_INIT,
  GET_UTILIZATION_PERCENTAGE_SUCCESS,
  GET_UTILIZATION_PERCENTAGE_FAILED,
  GET_PROJECT_LIST_INIT,
  GET_PROJECT_LIST_SUCCESS,
  GET_PROJECT_LIST_FAILED,
  GET_RESOURCES_BY_LOCATION_INIT,
  GET_RESOURCES_BY_LOCATION_SUCCESS,
  GET_RESOURCES_BY_LOCATION_FAILED,
  GET_UTILIZATION_GRAPH_BY_ID_INIT,
  GET_UTILIZATION_GRAPH_BY_ID_SUCCESS,
  GET_UTILIZATION_GRAPH_BY_ID_FAILED,
  GET_INHOUSE_RESOURCE_DETAILS_INIT,
  GET_INHOUSE_RESOURCE_DETAILS_SUCCESS,
  GET_INHOUSE_RESOURCE_DETAILS_FAILED,
  GET_VENDOR_RESOURCE_DETAILS_INIT,
  GET_VENDOR_RESOURCE_DETAILS_SUCCESS,
  GET_VENDOR_RESOURCE_DETAILS_FAILED,
  GET_RESOURCES_BY_DEPARTMENT_INIT,
  GET_RESOURCES_BY_DEPARTMENT_SUCCESS,
  GET_RESOURCES_BY_DEPARTMENT_FAILED,
  GET_RESOURCES_BY_PROJECT_INIT,
  GET_RESOURCES_BY_PROJECT_SUCCESS,
  GET_RESOURCES_BY_PROJECT_FAILED,
  GET_RESOURCES_BY_UTILIZATION_INIT,
  GET_RESOURCES_BY_UTILIZATION_SUCCESS,
  GET_RESOURCES_BY_UTILIZATION_FAILED,
  GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_INIT,
  GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_SUCCESS,
  GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_FAILED,
  GET_ALLOCATION_BY_MAPID_INIT,
  GET_ALLOCATION_BY_MAPID_SUCCESS,
  GET_ALLOCATION_BY_MAPID_FAILED,
  GET_RESOURCES_BY_PROJECT_OWNER_INIT,
  GET_RESOURCES_BY_PROJECT_OWNER_SUCCESS,
  GET_RESOURCES_BY_PROJECT_OWNER_FAILED,
  GET_RESOURCE_ALL_ALLOCATIONS_CHART_INIT,
  GET_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS,
  GET_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED,
  UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_INIT,
  UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS,
  UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED,
  DOWNLOAD_CREATE_RESOURCE_EXCEL_INIT,
  DOWNLOAD_CREATE_RESOURCE_EXCEL_SUCCESS,
  DOWNLOAD_CREATE_RESOURCE_EXCEL_FAILED,
  UPLOAD_RESOURCE_INIT,
  UPLOAD_RESOURCE_SUCCESS,
  UPLOAD_RESOURCE_FAILED,
  ALL_RESOURCES_GANTT_CHART_INIT,
  ALL_RESOURCES_GANTT_CHART_SUCCESS,
  ALL_RESOURCES_GANTT_CHART_FAILED,
  GET_DEPARTMENTS_RESOURCES_INIT,
  GET_DEPARTMENTS_RESOURCES_SUCCESS,
  GET_DEPARTMENTS_RESOURCES_FAILED,
  GET_RESOURCE_HIERARCHY_INIT,
  GET_RESOURCE_HIERARCHY_SUCCESS,
  GET_RESOURCE_HIERARCHY_FAILED,
  GET_SPECIFIC_RESOURCE_HIERARCHY_INIT,
  GET_SPECIFIC_RESOURCE_HIERARCHY_SUCCESS,
  GET_SPECIFIC_RESOURCE_HIERARCHY_FAILED,
  GET_RESOURCE_REQUESTS_INIT,
  GET_RESOURCE_REQUESTS_SUCCESS,
  GET_RESOURCE_REQUESTS_FAILED,
  DOWNLOAD_RESOURCE_ANALYTICS_INIT,
  DOWNLOAD_RESOURCE_ANALYTICS_SUCCESS,
  DOWNLOAD_RESOURCE_ANALYTICS_FAILED,
  GET_DEPARTMENTS_INIT,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_FAILED,
  GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_INIT,
  GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_SUCCESS,
  GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_FAILED,
  GET_SWAP_RESOURCES_ELIGIBLE_LIST_INIT,
  GET_SWAP_RESOURCES_ELIGIBLE_LIST_SUCCESS,
  GET_SWAP_RESOURCES_ELIGIBLE_LIST_FAILED,
  SWAP_RESOURCE_INIT,
  SWAP_RESOURCE_SUCCESS,
  SWAP_RESOURCE_FAILED,
  GET_SEARCH_FILTERS_FOR_UNNAMED_INIT,
  GET_SEARCH_FILTERS_FOR_UNNAMED_SUCCESS,
  GET_SEARCH_FILTERS_FOR_UNNAMED_FAILED,
  ASSIGN_RESOURCE_TO_UNNAMED_INIT,
  ASSIGN_RESOURCE_TO_UNNAMED_SUCCESS,
  ASSIGN_RESOURCE_TO_UNNAMED_FAILED,
  GET_PROJECT_REQUESTS_INIT,
  GET_PROJECT_REQUESTS_SUCCESS,
  GET_PROJECT_REQUESTS_FAILED,
  GET_ALLOCATION_MATRIX_ALL_RESOURCES_INIT,
  GET_ALLOCATION_MATRIX_ALL_RESOURCES_SUCCESS,
  GET_ALLOCATION_MATRIX_ALL_RESOURCES_FAILED,
  GET_PROFILE_INIT,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILED,
  GET_PROJECT_NOTIFICATION_COUNT_INIT,
  GET_PROJECT_NOTIFICATION_COUNT_SUCCESS,
  GET_PROJECT_NOTIFICATION_COUNT_FAILED,
  GET_NOTIFICATION_VIEWED_INIT,
  GET_NOTIFICATION_VIEWED_SUCCESS,
  GET_NOTIFICATION_VIEWED_FAILED,
  CLEAR_NOTIFICATIONS,
  CLEAR_GANTT_CHART_BY_DEPARTMENT,
  CLEAR_GANTT_CHART_BY_NAMED,
  COMPLIANCE_REPORT_RESOURCE_INIT,
  COMPLIANCE_REPORT_RESOURCE_SUCCESS,
  COMPLIANCE_REPORT_RESOURCE_FAILED,
  DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_INIT,
  DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_SUCCESS,
  DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_FAILED,
  ACCEPT_COMPLETE_RESOURCE_INIT,
  ACCEPT_COMPLETE_RESOURCE_SUCCESS,
  ACCEPT_COMPLETE_RESOURCE_FAILED,
  DOWNLOAD_RESOURCE_INIT,
  DOWNLOAD_RESOURCE_SUCCESS,
  DOWNLOAD_RESOURCE_FAILED,
  UPDATE_RESOURCES_BY_PROJECT_INIT,
  UPDATE_RESOURCES_BY_PROJECT_SUCCESS,
  UPDATE_RESOURCES_BY_PROJECT_FAILED,
  GET_REQUEST_DETAILS_BY_MAPID_INIT,
  GET_REQUEST_DETAILS_BY_MAPID_SUCCESS,
  GET_REQUEST_DETAILS_BY_MAPID_FAILED,
  REJECT_RESOURCE_INIT,
  REJECT_RESOURCE_SUCCESS,
  REJECT_RESOURCE_FAILED,
  ACCEPT_ALL_RESOURCE_REQUESTS_INIT,
  ACCEPT_ALL_RESOURCE_REQUESTS_SUCCESS,
  ACCEPT_ALL_RESOURCE_REQUESTS_FAILED,
  ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_INIT,
  ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_SUCCESS,
  ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_FAILED,
  DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_INIT,
  DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_SUCCESS,
  DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_FAILED,
} from "../actions/types/resource-management-types";

export const initialState = {
  createResourceData: 0,
  loadingAPI: true,
  resourceAnalyticsData: [],
  totalResourcesData: [],
  resourcesByRolesData: [],
  departmentsResourcesData: [],
  resourceHierarchyData: [],
  specificResourceHierarchyData: [],
  resoureDetailsData: [],
  updateResourceData: [],
  resourceMatrixData: [],
  allocationDataLimits: [],
  updateAllocationLimits: [],
  utilizationLevelData: [],
  utilizationPercentageData: [],
  projectList: [],
  resourcesByLocationData: [],
  getUtilizationGraphData: [],
  inhouseResourceDetailsData: [],
  vendorResourceDetailsData: [],
  resourcesByDepartmentData: [],
  resourcesByProjectData: [],
  resourcesByUtilizationData: [],
  aggregateResourcesAllocationMatrix: [],
  allocationDataByMapIDData: [],
  resourcesByProjectOwnerData: [],
  resourceAllAllocationChartData: {},
  updateResourceAllAllocationChartData: [],
  downloadResourceExcelData: "",
  uploadResourceData: [],
  allResourcesGanttChartData: "",
  resourceNotificationData: [],
  projectNotificationData: [],
  resourceAnalyticsDownloadedData: "",
  departmentsData: [],
  allResourcesDepartmentAllocationData: "",
  swapResourcesListData: [],
  swapResourceData: "",
  unnamedSearchFiltersData: [],
  unnamedAssignResourceData: [],
  allResourcesAllocationData: [],
  profileDetails: [],
  notificationCountData: [],
  notificationViewed: [],
  downdloadComplianceReportResourceData: "",
  complianceReportResourceData: [],
  acceptCompleteResourceData: [],
  downloadResourceData: "",
  updateResourcesByProjectData: [],
  resourceRequestDetailsByMapIDData: [],
  rejectResourceData: [],
  acceptAllResourcesRequestsData: [],
  acceptAllResourcesRequestsByProjectData: [],
  resourceFilteredAnalyticsDownloadedData: "",
};

const handlers = {
  [CREATE_RESOURCE_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [CREATE_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    createResourceData: action.response,
    loadingAPI: false,
  }),
  [CREATE_RESOURCE_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_RESOURCE_ANALYTICS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_RESOURCE_ANALYTICS_SUCCESS]: (state, action) => ({
    ...state,
    resourceAnalyticsData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCE_ANALYTICS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_TOTAL_RESOURCES_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_TOTAL_RESOURCES_SUCCESS]: (state, action) => ({
    ...state,
    totalResourcesData: action.response,
    loadingAPI: false,
  }),
  [GET_TOTAL_RESOURCES_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_RESOURCES_BY_ROLES_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_RESOURCES_BY_ROLES_SUCCESS]: (state, action) => ({
    ...state,
    resourcesByRolesData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCES_BY_ROLES_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_RESOURCE_DETAILS_BY_ID_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_RESOURCE_DETAILS_BY_ID_SUCCESS]: (state, action) => ({
    ...state,
    resoureDetailsData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCE_DETAILS_BY_ID_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_RESOURCE_DETAILS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [UPDATE_RESOURCE_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    updateResourceData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_RESOURCE_DETAILS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_RESOURCE_ALLOCATION_MATRIX_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_RESOURCE_ALLOCATION_MATRIX_SUCCESS]: (state, action) => ({
    ...state,
    resourceMatrixData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCE_ALLOCATION_MATRIX_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS]: (state) => ({
    ...state,
    allocationDataLimits: undefined,
    loadingAPI: true,
  }),
  [GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_SUCCESS]: (state, action) => ({
    ...state,
    allocationDataLimits: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_SUCCESS]: (state, action) => ({
    ...state,
    updateAllocationLimits: action.response,
    loadingAPI: false,
  }),
  [UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_UTILIZATION_LEVEL_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_UTILIZATION_LEVEL_SUCCESS]: (state, action) => ({
    ...state,
    utilizationLevelData: action.response,
    loadingAPI: false,
  }),
  [GET_UTILIZATION_LEVEL_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CLEAR_RM_LANDING_DATA]: (state, action) => ({
    ...state,
    utilizationLevelData: [],
    totalResourcesData: [],
    resourcesByRolesData: [],
    resourceAnalyticsData: [],
    utilizationPercentageData: [],
    resourcesByLocationData: [],
    loadingAPI: false,
  }),

  [GET_UTILIZATION_PERCENTAGE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_UTILIZATION_PERCENTAGE_SUCCESS]: (state, action) => ({
    ...state,
    utilizationPercentageData: action.response,
    loadingAPI: false,
  }),
  [GET_UTILIZATION_PERCENTAGE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_PROJECT_LIST_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_PROJECT_LIST_SUCCESS]: (state, action) => ({
    ...state,
    projectList: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_LIST_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_RESOURCES_BY_LOCATION_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_RESOURCES_BY_LOCATION_SUCCESS]: (state, action) => ({
    ...state,
    resourcesByLocationData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCES_BY_LOCATION_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_UTILIZATION_GRAPH_BY_ID_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_UTILIZATION_GRAPH_BY_ID_SUCCESS]: (state, action) => ({
    ...state,
    getUtilizationGraphData: action.response,
    loadingAPI: false,
  }),
  [GET_UTILIZATION_GRAPH_BY_ID_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_INHOUSE_RESOURCE_DETAILS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_INHOUSE_RESOURCE_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    inhouseResourceDetailsData: action.response,
    loadingAPI: false,
  }),
  [GET_INHOUSE_RESOURCE_DETAILS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_VENDOR_RESOURCE_DETAILS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_VENDOR_RESOURCE_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    vendorResourceDetailsData: action.response,
    loadingAPI: false,
  }),
  [GET_VENDOR_RESOURCE_DETAILS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_RESOURCES_BY_DEPARTMENT_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_RESOURCES_BY_DEPARTMENT_SUCCESS]: (state, action) => ({
    ...state,
    resourcesByDepartmentData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCES_BY_DEPARTMENT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_RESOURCES_BY_PROJECT_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_RESOURCES_BY_PROJECT_SUCCESS]: (state, action) => ({
    ...state,
    resourcesByProjectData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCES_BY_PROJECT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_RESOURCES_BY_UTILIZATION_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_RESOURCES_BY_UTILIZATION_SUCCESS]: (state, action) => ({
    ...state,
    resourcesByUtilizationData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCES_BY_UTILIZATION_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_INIT]: (state) => ({
    ...state,
    aggregateResourcesAllocationMatrix: [],
    loadingAPI: true,
  }),
  [GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_SUCCESS]: (state, action) => ({
    ...state,
    aggregateResourcesAllocationMatrix: action.response,
    loadingAPI: false,
  }),
  [GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_ALLOCATION_BY_MAPID_INIT]: (state) => ({
    ...state,
    allocationDataByMapIDData: undefined,
    loadingAPI: true,
  }),
  [GET_ALLOCATION_BY_MAPID_SUCCESS]: (state, action) => ({
    ...state,
    allocationDataByMapIDData: action.response,
    loadingAPI: false,
  }),
  [GET_ALLOCATION_BY_MAPID_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_RESOURCES_BY_PROJECT_OWNER_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_RESOURCES_BY_PROJECT_OWNER_SUCCESS]: (state, action) => ({
    ...state,
    resourcesByProjectOwnerData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCES_BY_PROJECT_OWNER_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_RESOURCE_ALL_ALLOCATIONS_CHART_INIT]: (state) => ({
    ...state,
    resourceAllAllocationChartData: {},
    loadingAPI: true,
  }),
  [GET_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS]: (state, action) => ({
    ...state,
    resourceAllAllocationChartData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_INIT]: (state) => ({
    ...state,
    updateResourceAllAllocationChartData: 0,
    loadingAPI: true,
  }),
  [UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS]: (state, action) => ({
    ...state,
    updateResourceAllAllocationChartData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [DOWNLOAD_CREATE_RESOURCE_EXCEL_INIT]: (state) => ({
    ...state,
    downloadResourceExcelData: "",
    loadingAPI: true,
  }),
  [DOWNLOAD_CREATE_RESOURCE_EXCEL_SUCCESS]: (state, action) => ({
    ...state,
    downloadResourceExcelData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_CREATE_RESOURCE_EXCEL_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPLOAD_RESOURCE_INIT]: (state) => ({
    ...state,
    uploadResourceData: [],
    loadingAPI: true,
  }),
  [UPLOAD_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    uploadResourceData: action.response,
    loadingAPI: false,
  }),
  [UPLOAD_RESOURCE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [ALL_RESOURCES_GANTT_CHART_INIT]: (state) => ({
    ...state,
    allResourcesGanttChartData: "",
    loadingAPI: true,
  }),
  [ALL_RESOURCES_GANTT_CHART_SUCCESS]: (state, action) => ({
    ...state,
    allResourcesGanttChartData: action.response,
    loadingAPI: false,
  }),
  [ALL_RESOURCES_GANTT_CHART_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DEPARTMENTS_RESOURCES_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_DEPARTMENTS_RESOURCES_SUCCESS]: (state, action) => ({
    ...state,
    departmentsResourcesData: action.response,
    loadingAPI: false,
  }),
  [GET_DEPARTMENTS_RESOURCES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_RESOURCE_HIERARCHY_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_RESOURCE_HIERARCHY_SUCCESS]: (state, action) => ({
    ...state,
    resourceHierarchyData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCE_HIERARCHY_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_SPECIFIC_RESOURCE_HIERARCHY_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_SPECIFIC_RESOURCE_HIERARCHY_SUCCESS]: (state, action) => ({
    ...state,
    specificResourceHierarchyData: action.response,
    loadingAPI: false,
  }),
  [GET_SPECIFIC_RESOURCE_HIERARCHY_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_RESOURCE_REQUESTS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_RESOURCE_REQUESTS_SUCCESS]: (state, action) => ({
    ...state,
    resourceNotificationData: action.response,
    loadingAPI: false,
  }),
  [GET_RESOURCE_REQUESTS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_PROJECT_REQUESTS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PROJECT_REQUESTS_SUCCESS]: (state, action) => ({
    ...state,
    projectNotificationData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_REQUESTS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [DOWNLOAD_RESOURCE_ANALYTICS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [DOWNLOAD_RESOURCE_ANALYTICS_SUCCESS]: (state, action) => ({
    ...state,
    resourceAnalyticsDownloadedData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_RESOURCE_ANALYTICS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_SUCCESS]: (state, action) => ({
    ...state,
    resourceFilteredAnalyticsDownloadedData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DEPARTMENTS_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_DEPARTMENTS_SUCCESS]: (state, action) => ({
    ...state,
    departmentsData: action.response,
    loadingAPI: false,
  }),
  [GET_DEPARTMENTS_FAILED]: (state) => ({ ...state, loadingAPI: false }),

  [GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    allResourcesDepartmentAllocationData: "",
  }),
  [GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_SUCCESS]: (state, action) => ({
    ...state,
    allResourcesDepartmentAllocationData: action.response,
    loadingAPI: false,
  }),
  [GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CLEAR_GANTT_CHART_BY_NAMED]: (state, action) => ({
    ...state,
    allResourcesDepartmentAllocationData: [],
    loadingAPI: false,
  }),

  [GET_SWAP_RESOURCES_ELIGIBLE_LIST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    swapResourcesListData: [],
  }),
  [GET_SWAP_RESOURCES_ELIGIBLE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    swapResourcesListData: action.response,
    loadingAPI: false,
  }),
  [GET_SWAP_RESOURCES_ELIGIBLE_LIST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [SWAP_RESOURCE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    swapResourceData: "",
  }),
  [SWAP_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    swapResourceData: action.response,
    loadingAPI: false,
  }),
  [SWAP_RESOURCE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_SEARCH_FILTERS_FOR_UNNAMED_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_SEARCH_FILTERS_FOR_UNNAMED_SUCCESS]: (state, action) => ({
    ...state,
    unnamedSearchFiltersData: action.response,
    loadingAPI: false,
  }),
  [GET_SEARCH_FILTERS_FOR_UNNAMED_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [ASSIGN_RESOURCE_TO_UNNAMED_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [ASSIGN_RESOURCE_TO_UNNAMED_SUCCESS]: (state, action) => ({
    ...state,
    unnamedAssignResourceData: action.response,
    loadingAPI: false,
  }),
  [ASSIGN_RESOURCE_TO_UNNAMED_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_ALLOCATION_MATRIX_ALL_RESOURCES_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_ALLOCATION_MATRIX_ALL_RESOURCES_SUCCESS]: (state, action) => ({
    ...state,
    allResourcesAllocationData: action.response,
    loadingAPI: false,
  }),
  [GET_ALLOCATION_MATRIX_ALL_RESOURCES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CLEAR_GANTT_CHART_BY_DEPARTMENT]: (state, action) => ({
    ...state,
    allResourcesAllocationData: [],
    loadingAPI: false,
  }),
  [GET_PROFILE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PROFILE_SUCCESS]: (state, action) => ({
    ...state,
    profileDetails: action.response,
    loadingAPI: false,
  }),
  [GET_PROFILE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_PROJECT_NOTIFICATION_COUNT_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PROJECT_NOTIFICATION_COUNT_SUCCESS]: (state, action) => ({
    ...state,
    notificationCountData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_NOTIFICATION_COUNT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_NOTIFICATION_VIEWED_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_NOTIFICATION_VIEWED_SUCCESS]: (state, action) => ({
    ...state,
    notificationViewed: action.response,
    loadingAPI: false,
  }),
  [GET_NOTIFICATION_VIEWED_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CLEAR_NOTIFICATIONS]: (state, action) => ({
    ...state,
    resourceNotificationData: [],
    projectNotificationData: [],
  }),

  [DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    downdloadComplianceReportResourceData: "",
  }),
  [DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    downdloadComplianceReportResourceData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [COMPLIANCE_REPORT_RESOURCE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    complianceReportResourceData: "",
  }),
  [COMPLIANCE_REPORT_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    complianceReportResourceData: action.response,
    loadingAPI: false,
  }),
  [COMPLIANCE_REPORT_RESOURCE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [ACCEPT_COMPLETE_RESOURCE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    acceptCompleteResourceData: [],
  }),
  [ACCEPT_COMPLETE_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    acceptCompleteResourceData: action.response,
    loadingAPI: false,
  }),
  [ACCEPT_COMPLETE_RESOURCE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [DOWNLOAD_RESOURCE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    downloadResourceData: "",
  }),
  [DOWNLOAD_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    downloadResourceData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_RESOURCE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_RESOURCES_BY_PROJECT_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    updateResourcesByProjectData: [],
  }),
  [UPDATE_RESOURCES_BY_PROJECT_SUCCESS]: (state, action) => ({
    ...state,
    updateResourcesByProjectData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_RESOURCES_BY_PROJECT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_REQUEST_DETAILS_BY_MAPID_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    resourceRequestDetailsByMapIDData: [],
  }),
  [GET_REQUEST_DETAILS_BY_MAPID_SUCCESS]: (state, action) => ({
    ...state,
    resourceRequestDetailsByMapIDData: action.response,
    loadingAPI: false,
  }),
  [GET_REQUEST_DETAILS_BY_MAPID_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [REJECT_RESOURCE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    rejectResourceData: [],
  }),
  [REJECT_RESOURCE_SUCCESS]: (state, action) => ({
    ...state,
    rejectResourceData: action.response,
    loadingAPI: false,
  }),
  [REJECT_RESOURCE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [ACCEPT_ALL_RESOURCE_REQUESTS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    acceptAllResourcesRequestsData: [],
  }),
  [ACCEPT_ALL_RESOURCE_REQUESTS_SUCCESS]: (state, action) => ({
    ...state,
    acceptAllResourcesRequestsData: action.response,
    loadingAPI: false,
  }),
  [ACCEPT_ALL_RESOURCE_REQUESTS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    acceptAllResourcesRequestsByProjectData: [],
  }),
  [ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_SUCCESS]: (state, action) => ({
    ...state,
    acceptAllResourcesRequestsByProjectData: action.response,
    loadingAPI: false,
  }),
  [ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
};

export default function resourceManagementReducer(
  state = initialState,
  action
) {
  const handler = handlers[action.type];
  if (!handler) return state;
  return { ...state, ...handler(state, action) };
}
